// Shared by the queue list, the drawer, the board and the calendar.
export const STATE_LABEL = {
  idea: "Idea", drafting: "Drafting", review: "Review",
  queued: "Queued", published: "Published", killed: "Killed",
};

export const CHANNEL_LABEL = {
  site_article: "Site article",
  site_enrichment: "Site enrichment",
  newsletter: "Newsletter",
  linkedin: "LinkedIn",
  instagram: "Instagram",
  youtube: "YouTube",
};

// Who a Playbook card asks something of. Ward opens this section wanting to
// know which cards are his; the pill answers that without him opening one.
export const OWNER_LABEL = { ward: "For Ward", marco: "For Marco", both: "Both" };

export const OWNER_OPTIONS = ["", "ward", "marco", "both"];

// Task priority. Three levels, not a boolean: "high" has to mean something,
// and it only does if there is somewhere below it for the rest to sit.
export const PRIORITY_LABEL = { high: "High", normal: "Normal", low: "Low" };
export const PRIORITY_ORDER = ["high", "normal", "low"];

export const STATE_ORDER = ["idea", "drafting", "review", "queued", "published", "killed"];

export const AUTHOR_OPTIONS = ["ward", "marco", "ai"];

// The three named in the repository. The other five live in the strategy
// artifact "The Room Is the Product"; free text until that list arrives.
export const PILLARS = [
  "The Case for an Athlete",
  "The Planner's Playbook",
  "The Room Is the Product",
];

// The Playbook card the approve-checklist links back to ("How a piece gets
// checked"). Named here so the drawer and the Playbook agree on it.
export const CHECKS_CARD_SLUG = "how-a-piece-gets-checked";

// The id of the anchor PlaybookCard puts on a check's line in that card's
// body, and the drawer scrolls to.
export const checkAnchorId = (checkId) => `mk-check-anchor-${checkId}`;
